import { useRef } from 'react'

/**
 * EditableInput — a label that turns into a text input on click.
 *
 * Uncontrolled while editing (defaultValue, not value): the parent isn't
 * notified on every keystroke, only when the edit commits via onSave.
 * Enter commits (blurs the input); Escape cancels without saving.
 */
const EditableInput = ({
  editing,
  setEditing,
  value,
  placeholder = 'Title',
  onSave,
  icon,
  style,
  inputStyle,
  className,
  inputClassName,
  inputWrapperStyle,
}) => {
  const inputRef = useRef(null)

  if (editing) {
    return (
      <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', ...inputWrapperStyle }}>
        <input
          ref={inputRef}
          type='text'
          autoFocus
          defaultValue={value ?? ''}
          placeholder={placeholder}
          className={inputClassName}
          style={{
            border: 'none',
            outline: 'none',
            fontSize: '12px',
            fontWeight: 500,
            fontFamily: 'Inter',
            background: 'transparent',
            paddingRight: icon ? '18px' : 0,
            width: '100px',
            ...inputStyle
          }}
          onBlur={event => {
            setEditing(false)
            onSave(event.target.value)
          }}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              event.target.blur()
            } else if (event.key === 'Escape') {
              setEditing(false)
            }
          }}
        />
        {icon && (
          <span
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              display: 'inline-flex',
              alignItems: 'center',
              pointerEvents: 'none'
            }}
          >
            {icon}
          </span>
        )}
      </div>
    )
  }

  return (
    <div
      onClick={() => setEditing(true)}
      className={className}
      style={{
        cursor: 'text',
        fontSize: '12px',
        fontWeight: 500,
        fontFamily: 'Inter',
        ...style
      }}
    >
      {value || placeholder}
    </div>
  )
}

export default EditableInput
